import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { request } from "@/js/http/http_request";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import PaymentBadge from "@/components/payment/PaymentBadge.vue";
import { paymentState as _paymentState, listTerms, orderStatus, getOrderStatusIcon, defaultPagingChoices } from "@/js/lists.ts";
import { isProfessional } from "@/js/http/auth.js";
import { getOrderConfirmationReference } from "@/js/order/order.js";
import { getSymbolCurrency, formatPrice } from "@/js/currency/currencies.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ImportOrderDialogVue from "@/components/order/ImportOrderDialog.vue";
import { setFilters, getFilters } from "@/js/filter/filter.js";
export default {
  name: "UserOrderList",
  data: function data(_this) {
    return {
      isImportOrderShown: false,
      listTerms: listTerms,
      mustBeFinalizedOrders: {},
      baseModel: {
        orders: [],
        numberOfOrders: 0,
        numberOfPages: 0
      },
      formSearch: {
        label: "",
        paymentStates: [],
        status_allowed: [],
        excludeWineDetails: true,
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        },
        sort_by: null,
        range_date: []
      },
      dataLoading: true,
      pagingLimitsChoices: defaultPagingChoices,
      orderStatus: orderStatus,
      sortBy: [{
        id: "ASCENDING_DATE",
        label: "Ascending date"
      }, {
        id: "DESCENDING_DATE",
        label: "Descending date"
      }, {
        id: "RANGE_DATE",
        label: "Range dates"
      }],
      rangeDatesDisplay: [],
      sortByRangeDatesMenu: false
    };
  },
  computed: {
    paymentState: function paymentState() {
      return _paymentState;
    },
    filterByOrderStatusAllowed: function filterByOrderStatusAllowed() {
      return orderStatus.filter(function (os) {
        return os.id !== "CREATED";
      });
    },
    isFilteringStatus: function isFilteringStatus() {
      return this.isFilteringToValidate || this.isFilteringInPreparation || this.isFilteringInTransit || this.isFilteringHeld || this.isFilteringDelivered || this.isFilteringCancelled;
    },
    isFilteringToValidate: function isFilteringToValidate() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "ADJUSTING" || x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringToConsolidate: function isFilteringToConsolidate() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "VALIDATED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringToShip: function isFilteringToShip() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "IN_PREPARATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInPreparation: function isFilteringInPreparation() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "VALIDATED" || x.id == "IN_PREPARATION";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringInTransit: function isFilteringInTransit() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "DELIVERY" || x.id == "CUSTOMS_CLEARANCE";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringHeld: function isFilteringHeld() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "ON_HOLD";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringDelivered: function isFilteringDelivered() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "DELIVERED" || x.id == "INBOUND";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    isFilteringCancelled: function isFilteringCancelled() {
      return this.formSearch.status_allowed.some(function (x) {
        return orderStatus.filter(function (x) {
          return x.id == "CANCELLED";
        }).map(function (os) {
          return os.id;
        }).includes(x);
      });
    },
    canImportOrder: function canImportOrder() {
      return this.$whitelabel.isExportPriceList && isProfessional(this.loggedUserData);
    }
  },
  components: {
    Confirm: Confirm,
    PaymentBadge: PaymentBadge,
    ImportOrderDialogVue: ImportOrderDialogVue,
    paging: pagingComponent,
    index: indexComponent
  },
  props: {
    loggedUserData: Object,
    filters: {
      default: false
    }
  },
  created: function created() {
    var filters = getFilters();
    if (filters !== null && filters !== void 0 && filters.orders) {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), filters.orders);
    }
  },
  mounted: function mounted() {
    this.search(true);
  },
  methods: {
    clearFiltersStatus: function clearFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        status_allowed: []
      });
      this.search(true);
    },
    fillFiltersStatus: function fillFiltersStatus() {
      this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
        status_allowed: this.filterByOrderStatusAllowed.map(function (x) {
          return x.id;
        })
      });
      this.search(true);
    },
    hasBeenValidated: function hasBeenValidated(order) {
      return !orderStatus.filter(function (x) {
        return ["AWAITING_CUSTOMER_VALIDATION", "AWAITING_VALIDATION", "ADJUSTING"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(order.status);
    },
    isShipped: function isShipped(order) {
      return orderStatus.filter(function (x) {
        return ["INBOUND", "DELIVERY", "CUSTOMS_CLEARANCE", "DELIVERED"].includes(x.id);
      }).map(function (x) {
        return x.status;
      }).includes(order.status);
    },
    isInvoiceConsultable: function isInvoiceConsultable(order) {
      var _order$importer;
      return order.isInvoiced && !((_order$importer = order.importer) !== null && _order$importer !== void 0 && _order$importer.id) && (this.isShipped(order) || order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status);
    },
    isImporterInvoiceConsultable: function isImporterInvoiceConsultable(order) {
      return order.isImporterInvoiced && (this.isShipped(order) || order.status == orderStatus.find(function (os) {
        return os.id === "CANCELLED";
      }).status);
    },
    clearDateRange: function clearDateRange() {
      this.formSearch.range_date = [];
      this.search(true);
    },
    changeFilterBy: function changeFilterBy() {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      this.search(true);
    },
    fastFilter: function fastFilter(type) {
      this.formSearch.paging = {
        limits: 24,
        currentPage: 0,
        askedPage: 0
      };
      switch (type) {
        case "to_validate":
          if (this.isFilteringToValidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION" && id !== "ADJUSTING";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "AWAITING_CUSTOMER_VALIDATION" && id !== "AWAITING_VALIDATION" && id !== "ADJUSTING";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "AWAITING_CUSTOMER_VALIDATION" || x.id == "AWAITING_VALIDATION" || x.id == "ADJUSTING";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_consolidate":
          if (this.isFilteringToConsolidate) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "VALIDATED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "to_ship":
          if (this.isFilteringToShip) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "IN_PREPARATION";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_preparation":
          if (this.isFilteringInPreparation) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED" && id !== "IN_PREPARATION";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "VALIDATED" && id !== "IN_PREPARATION";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "VALIDATED" || x.id == "IN_PREPARATION";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "held":
          if (this.isFilteringHeld) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "ON_HOLD";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "ON_HOLD";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "ON_HOLD";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "in_transit":
          if (this.isFilteringInTransit) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERY" && id !== "CUSTOMS_CLEARANCE";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERY" && id !== "CUSTOMS_CLEARANCE";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id == "DELIVERY" || x.id == "CUSTOMS_CLEARANCE";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "delivered":
          if (this.isFilteringDelivered) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERED" && id !== "INBOUND";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "DELIVERED" && id !== "INBOUND";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "DELIVERED" || x.id === "INBOUND";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
        case "cancelled":
          if (this.isFilteringCancelled) {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: _toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "CANCELLED";
              }))
            });
          } else {
            this.formSearch = _objectSpread(_objectSpread({}, this.formSearch), {}, {
              status_allowed: [].concat(_toConsumableArray(this.formSearch.status_allowed.filter(function (id) {
                return id !== "CANCELLED";
              })), _toConsumableArray(orderStatus.filter(function (x) {
                return x.id === "CANCELLED";
              }).map(function (x) {
                return x.id;
              })))
            });
          }
          break;
      }
      this.changeFilterBy();
    },
    changeSortBy: function changeSortBy() {
      if (this.sortBy.find(function (x) {
        return x.id === "RANGE_DATE";
      }).id !== this.formSearch.sort_by) {
        this.search(true);
      }
    },
    sortByDatesRanges: function sortByDatesRanges() {
      if (this.formSearch.range_date.length >= 2) {
        this.sortByRangeDatesMenu = false;
        this.search(true);
      }
    },
    formatDates: function formatDates() {
      var formatedDates = [];
      this.formSearch.range_date.forEach(function (date) {
        formatedDates.push(new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }));
      });
      this.rangeDatesDisplay = formatedDates;
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    search: function search() {
      var _this2 = this;
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      this.dataLoading = true;
      var _this = this;
      if (isResetPaging) _this.resetPaging();
      setFilters(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          orders: _this2.formSearch
        });
      });
      return request("/v1/orders", "post", _this.formSearch, true, "api").then(function (response) {
        window.scrollTo({
          top: 0
        });
        _this.baseModel.orders.splice(_this.formSearch.paging.limits);
        _this.baseModel = {
          orders: response.data.orders,
          numberOfOrders: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / _this.formSearch.paging.limits)
        };
        _this.formSearch.paging.currentPage = _this.formSearch.paging.askedPage + 1;
        if (!_this.formSearch.paging.currentPage) {
          _this.formSearch.paging.currentPage = 0;
        }
        _this.mustBeFinalizedOrders = _this.baseModel.orders.filter(function (x) {
          var isConcernedStatus = x.status == orderStatus.filter(function (os) {
            return os.id === "AWAITING_CUSTOMER_VALIDATION";
          })[0].status || x.status == orderStatus.filter(function (os) {
            return os.id === "ADJUSTING";
          })[0].status;
          return isConcernedStatus;
        }).map(function (x) {
          return x.id_order;
        }).reduce(function (acc, x) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, x, true));
        }, {});
        _this.dataLoading = false;
        _this.$EventBus.$emit("loading", false);
      });
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.search();
      }
    },
    orderDetails: function orderDetails(idOrder) {
      return {
        name: "userOrderSummary",
        params: {
          id: idOrder
        }
      };
    },
    importOrder: function importOrder() {
      this.isImportOrderShown = true;
    },
    getOrderStatusIcon: getOrderStatusIcon,
    getSymbolCurrency: getSymbolCurrency,
    formatPrice: formatPrice,
    getOrderConfirmationReference: getOrderConfirmationReference
  }
};